import { useLanguage } from '../../contexts/LanguageContext';
import { categoriesLoaded } from './catalogCategories';
import { inCategoryFamily, setPartSize, type PartItem } from './partsRun';
import { SegmentedToggle } from './SegmentedToggle';

// A SCREW'S POINT, UNDER ITS SIZE (Louis 2026-10-29): pointed, it cuts its own way through every part
// it crosses and none is bored for it (see makesOwnHole); blunt, it goes into a hole, a nut or an
// insert. Read off the drawing by the parts call where the drawing shows the end; set here where it
// did not, or read wrong. Nothing for a part that is not a screw.
export function ScrewTip({ docId, index, part }: { docId: string; index: number; part: PartItem }) {
  const { t } = useLanguage();
  if (!categoriesLoaded() || !inCategoryFamily(part.category, new Set(['screws']))) return null;
  const tip = part.size?.tip ?? null;
  return (
    <div className="mt-2 flex flex-col items-center gap-1 font-sans">
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{t('notice.parts.tip')}</span>
      <SegmentedToggle
        small
        value={tip ?? 'unknown'}
        options={[
          { value: 'pointed', label: t('notice.parts.tipPointed') },
          { value: 'blunt', label: t('notice.parts.tipBlunt') },
          ...(tip ? [] : [{ value: 'unknown' as const, label: t('notice.parts.tipUnknown') }]),
        ]}
        onChange={(v) => {
          if (v === 'unknown') return;
          setPartSize(docId, index, { tip: v, source: part.size?.source ?? null, note: part.size?.note ?? null });
        }}
      />
    </div>
  );
}
